import AvailableProgram from "../Components/AvailableProgram/AvailableProgram";
import { useAuth } from "../Context/AuthContext";
import react, { useState, useEffect } from "react";
import { useHttpClient } from "../hooks/http-hook";
import { useTranslation } from "react-i18next";

function EnrolledPrograms() {
  const { sendRequest } = useHttpClient();
  const { authData } = useAuth();
  const [programs, setPrograms] = useState([]);
  const { t } = useTranslation();

  console.log(authData.role);

  // Importer les programme depuis la BD
  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const response = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + "/programs"
        );

        console.log("RESPONSE:", response);
        setPrograms(response.programs);
        //Filtrer les programmes selon ceux auquels je suis incrit
        if (authData.role === "user") {
          setPrograms((prevPrograms) =>
            prevPrograms.filter((prog) => {
              return prog.students_enrolled.includes(authData.userId);
            })
          );
        } else {
          setPrograms((prevPrograms) =>
            prevPrograms.filter((prog) => {
              return prog.created_by === authData.userId;
            })
          );
        }
      } catch (err) {
        console.error("ERROR:", err);
      }
    };
    fetchPrograms();
  }, [sendRequest]);
  return (
    <div>
      <h1 className="text-center mb-3">{t("my_courses")}</h1>
      <AvailableProgram programs={programs} />
    </div>
  );
}

export default EnrolledPrograms;
